import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { CommonService } from '../common/common.service';
import { APP_HOME_PATH } from 'src/app/constants/app.constant';
import { ObjectUtilService } from '../common/object-util.service';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  constructor(
    private common: CommonService,
    private router: Router,
    private objUtil: ObjectUtilService
  ) {
    router.events.subscribe((val) => {
      // see also
      if (val instanceof NavigationEnd) {
        const _this = this;
        var intervalId: any = null;
        var intervalFunction = function () {
          if (_this.menuItems.length) {
            clearInterval(intervalId);
            // console.log(val.urlAfterRedirects);
            let indexParamType = 0;
            let indexOfSemiColon = val.urlAfterRedirects.indexOf(';');
            let indexOfQuestion = val.urlAfterRedirects.indexOf('?');
            let state = val.urlAfterRedirects;

            let paramtype = null;
            if (indexOfSemiColon > 0) {
              indexParamType = indexOfSemiColon;
              paramtype = ';';
            } else if (indexOfQuestion > 0) {
              indexParamType = indexOfQuestion;
              paramtype = '?';
            }
            if (paramtype) {
              state = val.urlAfterRedirects.substring(0, indexParamType);
            } else {
              state = val.urlAfterRedirects;
            }

            let path = _this.common.findPathData(_this.menuItems, state);
            if (!!path && path.length) {
              _this.breadcrumbItemsTemp = [];
              if (state !== APP_HOME_PATH) {
                let currentMenu = _this.objUtil.copyObject(
                  _this.menuItems[path[0]] as any
                );

                _this.breadcrumbItemsTemp.push(currentMenu);
                path.splice(0, 1);

                path.forEach((x: string) => {
                  if (x !== 'routerLink' && x!== 'id') {
                    currentMenu = currentMenu[x];
                    if (x !== 'items') {
                      _this.breadcrumbItemsTemp.push(currentMenu);
                    }
                  }
                });
              }
              // console.log(_this.breadcrumbItemsTemp);
            }
          }
        };
        intervalId = setInterval(intervalFunction, 50);
      }
    });
  }

  //----------------------------  Valiable  --------------------------------//
  sidebarVisible: boolean = true;
  menuItems: MenuItem[] = [];
  breadcrumbItemsTemp: MenuItem[] = [];
  home!: MenuItem;

  //----------------------------  Get Set  --------------------------------//
  get breadcrumbItems() {
    return this.breadcrumbItemsTemp;
  }

  set breadcrumbItems(items: MenuItem[]) {
    this.breadcrumbItemsTemp = this.objUtil.copyObject(
      this.breadcrumbItemsTemp.concat(items)
    );
    // console.log(this.breadcrumbItemsTemp);
  }

  removeItemAt(index: number) {
    this.breadcrumbItemsTemp = this.objUtil.copyObject(
      this.breadcrumbItemsTemp
    );
    this.breadcrumbItemsTemp.splice(index, 1);
  }

  addItemAt(index: number, item: MenuItem) {
    this.breadcrumbItemsTemp = this.objUtil.copyObject(
      this.breadcrumbItemsTemp
    );
    this.breadcrumbItemsTemp.splice(index, 0, item);
  }
}
